import {Injectable} from '@angular/core';
import {RowArgs} from '@progress/kendo-angular-grid';
import {BehaviorSubject} from 'rxjs';

export type TDataItem = RowArgs['dataItem'];

@Injectable()
export class GridSelectorService {
  public selectedKeys$ = new BehaviorSubject<TDataItem[]>([]);

  public get isMultipleSelected() {
    return this.selectedKeys$.getValue().length > 1;
  }

  public getSelectionKey({dataItem}: RowArgs): TDataItem {
    return dataItem;
  }

  public handleKeySelectionChange(event: TDataItem[]) {
    this.selectedKeys$.next(event);
  }

  public resetSelectedKeys() {
    this.selectedKeys$.next([]);
  }
}
